module.exports = __webpack_public_path__ + "img/pp-43.5715e650.jpg";